import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getSessionCookie } from "../utils/cookies";

const PrivateRoute = () => {
  const token = getSessionCookie("accessToken");

  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
